var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "단지안내",
            "tabActive": "호수 배치도",
            "bg": "/images/sub/complex/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("단지안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("호수 배치도")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "page-section__content"
  }, [_c('v-row', {
    staticClass: "type-list"
  }, [_vm._l(_vm.types, function (type, index) {
    return [_c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('txt', {
      staticClass: "txt--lg mb-10px"
    }, [_vm._v(" " + _vm._s(type.name) + " ")]), _c('v-divider'), _c('div', {
      staticClass: "pa-18px pa-md-24px"
    }, [_c('v-row', {
      staticClass: "row--xs"
    }, [_vm._l(type.children, function (child, index) {
      return [_c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "md": "6"
        }
      }, [_c('v-sheet', {
        staticClass: "pa-16px",
        class: `bg-${child.name}`,
        attrs: {
          "rounded": "pill"
        }
      }, [_c('txt', {
        staticClass: "text-center"
      }, [_c('strong', {
        staticClass: "text-uppercase"
      }, [_vm._v(_vm._s(child.name) + " TYPE "), _c('br')]), _vm._v(" (" + _vm._s(child.total) + "세대 중 " + _vm._s(child.target) + "세대) ")])], 1)], 1)];
    })], 2)], 1), _c('v-divider')], 1)];
  })], 2)], 1), _c('div', {
    staticClass: "page-section__content"
  }, [_c('div', {
    staticClass: "v-data-table v-data-table--line v-data-table--density-compact"
  }, [_c('div', {
    staticClass: "v-data-table__wrapper"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th-primary', [_vm._v("층별")]), _vm._l(16, function (n, index) {
    return [_c('th-primary', {
      key: index
    }, [_vm._v(_vm._s(index + 1) + "호")])];
  })], 2)]), _c('tbody', [_vm._l(_vm.table, function (item, index) {
    return [_c('tr', {
      key: index
    }, [_c('th-secondary', [_vm._v(_vm._s(item.floor) + "층")]), _vm._l(item.rooms, function (room, index) {
      return [index < 16 ? [_c('td-primary', {
        key: index,
        class: `bg-${room.type}`
      }, [room.type ? [room.type === 'null' ? [_vm._v("-")] : [_vm._v(_vm._s(item.floor) + _vm._s(room.number))]] : _vm._e()], 2)] : _vm._e()];
    })], 2)];
  })], 2)])])])]), _c('div', {
    staticClass: "page-section__content"
  }, [_c('div', {
    staticClass: "v-data-table v-data-table--line v-data-table--density-compact"
  }, [_c('div', {
    staticClass: "v-data-table__wrapper"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th-primary', [_vm._v("층별")]), _vm._l(16, function (n, index) {
    return [_c('th-primary', {
      key: index
    }, [_vm._v(_vm._s(index + 17) + "호")])];
  })], 2)]), _c('tbody', [_vm._l(_vm.table, function (item, index) {
    return [_c('tr', {
      key: index
    }, [_c('th-secondary', [_vm._v(_vm._s(item.floor) + "층")]), _vm._l(item.rooms, function (room, index) {
      return [index > 15 ? [_c('td-primary', {
        key: index,
        class: `bg-${room.type}`
      }, [room.type ? [room.type === 'null' ? [_vm._v("-")] : [_vm._v(_vm._s(item.floor) + _vm._s(room.number))]] : _vm._e()], 2)] : _vm._e()];
    })], 2)];
  })], 2)])])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }